import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {Dictionary} from '../interface/dictionary';
import {first} from 'rxjs/operators';
import {ListResponse} from '../interface/response/list-response';
import {ex} from "@fullcalendar/core/internal-common";

export const DICT_TYPE_INSURANCE_TYPE = 'insurance_type';
export const INSURANCE_TYPE_ASSETS = 'assets';
export const INSURANCE_TYPE_LIFE = 'life';

export const PARTNER_STATUS_ACTIVE = 'active';
export const PARTNER_STATUS_NEW = 'new';
export const PARTNER_STATUS_INACTIVE = 'inactive';
export const OFWCA_STATUS_ACTIVE = 'active';
export const OFWCA_STATUS_INACTIVE = 'inactive';

export const DICT_TYPE_LEGAL_FORM = 'legal_form';
export const LEGAL_FORM_NATURAL_PERSON = 'natural_person';
export const LEGAL_FORM_LEGAL_PERSON = 'legal_person';

export const DICT_TYPE_FORM_OF_BUSINESS = 'form_of_business';
export const FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP = 'sole_proprietorship';
export const FORM_OF_BUSINESS_NONE_PROPRIETORSHIP = 'none_proprietorship';
export const FORM_OF_BUSINESS_PARTNERSHIP = 'partnership';

export const FORM_OF_BUSINESS_COOPERATIVE = 'cooperative';
export const FORM_OF_BUSINESS_GENERAL_PARTNERSHIP = 'general_partnership';
export const FORM_OF_BUSINESS_LIMITED_LIABILITY_PARTNERSHIP = 'limited_liability_partnership';
export const FORM_OF_BUSINESS_LIMITED_PARTNERSHIP = 'limited_partnership';
export const FORM_OF_BUSINESS_PARTNERSHIP_LIMITED_BY_SHARES = 'partnership_limited_by_shares';
export const  FORM_OF_BUSINESS_JOINT_STOCK_COMPANY = 'joint_stock_company';
export const  FORM_OF_BUSINESS_PRIVATE_LIMITED_COMPANY = 'private_limited_company';
export const FORM_OF_BUSINESS_FOREIGN_ACTIVITIES = 'foreign_activities';
export const FORM_OF_BUSINESS_ASSOCIATION = 'association';
export const DICT_TYPE_SEX = 'gender';
export const SEX_MALE = 'male';
export const SEX_FEMALE = 'female';

export const DICT_TYPE_COMPANY = 'company';
export const COMPANY_ASF = 'asf';
export const COMPANY_ASF_PREMIUM = 'asf_premium';

export const COMPANY_MULTISFERA =  'multisfera';

export const DICT_TYPE_CONTRACT_OWNER = 'contract_owner';
export const CONTRACT_OWNER_OFWCA = 'ofwca';
export const CONTRACT_OWNER_PARTNER = 'partner';
export const OFWCA_STATUS_NEW = 'new';

export const DICT_TYPE_CONTRACT_STATUS = 'contract_status';
export const CONTRACT_STATUS_NEW = 'new';
export const CONTRACT_STATUS_TO_TERMINATE = 'to_terminate';
export const CONTRACT_STATUS_DURING_TERMINATION = 'during_termination';
export const CONTRACT_STATUS_TERMINATED = 'terminated';
export const CONTRACT_STATUS_ACTIVE = 'active';
export const CONTRACT_STATUS_CANCELED = 'canceled';
export const CONTRACT_STATUS_CLOSED = 'closed';
export const CONTRACT_STATUS_SENT_WITH_AUTENTI = 'sent_with_autenti';
export const CONTRACT_STATUS_SENT_TO_AGENT = 'sent_to_agent';
export const CONTRACT_STATUS_DOWNLOADED = 'downloaded';
export const CONTRACT_STATUS_HANDED_OVER_REGIONAL = 'handed_over_regional';

export const DICT_TYPE_CONTRACT_TYPE = 'contract_type';
export const CONTRACT_TYPE_PARTNERSHIP = 'partnership';
export const CONTRACT_TYPE_PROFIT = 'profit';
export const CONTRACT_TYPE_MANDATE = 'mandate';
export const CONTRACT_TYPE_MANDATE_ONLY_HEALTH = 'mandate_only_health';
export const CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE = 'mandate_complete_package';
export const CONTRACT_TYPE_MANDATE_STUDENT = 'mandate_student';
export const CONTRACT_TYPE_TERMINAL = 'terminal';
export const CONTRACT_TYPE_FRANCHISE = 'franchise';
export const CONTRACT_TYPE_OCK = 'ock';
export const CONTRACT_TYPE_LEASING = 'leasing';
export const CONTRACT_TYPE_DURING_REGISTRATION = 'during_registration';
export const CONTRACT_TYPE_LEAD = 'lead';
export const CONTRACT_TYPE_FOR_DEREGISTRATION = 'for_deregistration';
export const CONTRACT_TYPE_SELF_BILLING = 'self_billing';
export const CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS = 'agreement_for_partner_points';
export const CONTRACT_TYPE_FRANCHISE_AGREEMENT = 'franchise_agreement';
export const CONTRACT_TYPE_LEAD_ONLY_HEALTH = 'lead_only_health';
export const CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE = 'lead_complete_package';

export const INVOICE_STATUS = 'invoice_status';
export const INVOICE_STATUS_TO_BE_REALIZED = 'to_be_realized';
export const INVOICE_STATUS_SENT_FOR_PAYMENT = 'sent_for_payment';
export const INVOICE_STATUS_PAID = 'paid';
export const INVOICE_STATUS_SUSPENDED = 'suspended';
export const INVOICE_STATUS_REJECTED = 'rejected';
export const INVOICE_STATUS_TO_BE_CORRECTED = 'to_be_corrected';

export  const FACILITY_TYPE = 'facility_type';
export const FACILITY_TYPE_OWN_ASF_PREMIUM = 'own_asf_premium';
export const FACILITY_TYPE_OWN_ASF = 'own_asf';
export const FACILITY_TYPE_SELF_GOOD_AGENT = 'self-good-agent';
export const FACILITY_TYPE_FRANCHISE_GOOD_AGENT = 'franchise_good_agent';
export const FACILITY_TYPE_AFFILIATE_GOOD_AGENT = 'affiliate_good_agent';
export const FACILITY_TYPE_SELF_AGENT = 'self_agent';
export const FACILITY_TYPE_WITH_ASF_MARKETING = 'with_asf_marking';

export const REPORT_TYPE_PARTNER = 'partner';
export const REPORT_TYPE_OFWCA = 'ofwca';
export const REPORT_TYPE_CONTRACT = 'contract';
export const REPORT_TYPE_REGISTRATION = 'registration';
export const REPORT_TYPE_COMMISSIONS = 'commissions';
export const REPORT_TYPE_PARTNER_REGIONAL = 'partner_regional';
export const REPORT_TYPE_OFWCA_REGIONAL = 'ofwca_regional';
export const REPORT_TYPE_IDENTIFIERS_REGIONAL = 'identifiers_regional';


export const REPORT_TYPE_IDENTIFIERS = 'identifiers';

export const CLIENT_TYPE = 'client_type';

export const CLIENT_TYPE_PARTNER = 'partner';
export const CLIENT_TYPE_OFWCA = 'ofwca';
export const CLIENT_TYPE_OFWCA_FROM_OUTSIDE = 'ofwca_from_outside';


export  const TYPE_OF_ACTIVITY_INTERPRETATION_OF_OWU = 'interpretation_of_owu';
export  const TYPE_OF_ACTIVITY_PREMIUM_CALCULATION = 'premium_calculation';
export  const TYPE_OF_ACTIVITY_OTHER = 'other';
export  const TYPE_OF_ACTIVITY_ISSUING_A_POLICY = 'issuing_a_policy';
export  const TYPE_OF_ACTIVITY_SYSTEM_HELP = 'system_help';
export  const TYPE_OF_ACTIVITY_SHIPPING_PREPARATION = 'shipping_preparation';
export  const TYPE_OF_ACTIVITY_SETTLEMENT_OF_DOCUMENTS = 'settlement_of_documents';
export  const TYPE_OF_ACTIVITY_DISTRIBUTING_SHORTAGES = 'distributing_shortages';
export  const TYPE_OF_ACTIVITY_AGENT_TRAINING = 'agent_training';
export  const TYPE_OF_ACTIVITY_EXPLANATION_OF_ERRORS = 'explanation_of_errors';
export  const TYPE_OF_ACTIVITY_PRODUCT_INQUIRY = 'product_inquiry';
export  const TYPE_OF_ACTIVITY_COMPARE_OFFERS = 'compare_offers';
export  const TYPE_OF_ACTIVITY_CALCULATION_AND_COMPARISON_OF_OFFERS = 'calculation_and_comparison_of_offers';
export  const TYPE_OF_ACTIVITY_PUBLICATION_OF_PRINTED_MATTER = 'publication_of_printed_matter';
export  const TYPE_OF_ACTIVITY_SERVICE_ASSISTANCE = 'service_assistance';
export  const TYPE_OF_ACTIVITY_COMMISSION_EXPLANATION = 'commission_explanation';
export  const TYPE_OF_ACTIVITY_NEGOTIATING_COMMISSIONS = 'negotiating_commissions';
export  const TYPE_OF_ACTIVITY_SALES_OFFICE = 'sales_office';
export  const TYPE_OF_ACTIVITY_SENDING_PROCESS_GUIDELINES_IN_TU = 'sending_process_guidelines_in_tu';
export  const TYPE_OF_ACTIVITY_NEGOTIATING_WITH_TU = 'negotiating_with_TU';
export  const TYPE_OF_ACTIVITY_SENDING_PROCESS_INSTRUCTIONS_IN_TU = 'sending_process_instructions_in_tu';
export  const TYPE_OF_ACTIVITY_COMPLETION_OF_DATE = 'completion_of_data';
export  const DICT_TYPE_SUPPORT_STATUS = 'support_status';
export  const SUPPORT_STATUS_DURING = 'during';
export  const SUPPORT_STATUS_CLOSED = 'closed';
export const REGISTRATION_CONTRACT_TYPES = [
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_MANDATE,
  CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
  CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
  CONTRACT_TYPE_PROFIT,
  CONTRACT_TYPE_DURING_REGISTRATION,
  CONTRACT_TYPE_FOR_DEREGISTRATION,
];

export const INSURANCE_COMPANY_ANNEX_CONTRACT_TYPES = [
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_MANDATE,
  CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
  CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
  CONTRACT_TYPE_MANDATE_STUDENT,
  CONTRACT_TYPE_PROFIT,
];

export const DICT_TYPE_FILE_TYPE = 'file_type';
export const FILE_TYPE_ALLIANZ_CERT = 'allianz_cert';
export const FILE_TYPE_ALLIANZ_CERT_DOCUMENTS = 'allianz_cert_documents';
export const FILE_TYPE_ALLIANZ_CERT_FRAUDS = 'allianz_cert_frauds';
export const FILE_TYPE_ALLIANZ_CERT_MY_CAR = 'allianz_cert_my_car';
export const FILE_TYPE_CONTRACT = 'contract';
export const FILE_TYPE_ANNEX_OFWCA_APPLICATION = 'annex_ofwca_application';
export const FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT = 'annex_commission_attachment';
export const FILE_TYPE_ANNEX = 'annex';
export const FILE_TYPE_CONTRACT_TERMINATION = 'contract_termination';
export const FILE_TYPE_DIPLOMA = 'diploma';
export const FILE_TYPE_AUTHORIZATION = 'authorization';
export const FILE_TYPE_CERT_100P = 'cert_100p';
export const FILE_TYPE_CERT_40P = 'cert_40p';
export const FILE_TYPE_KRS_CEIDG = 'krs_ceidg';
export const FILE_TYPE_KRK = 'krk';
export const FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA = 'information_clause_for_ofwca';
export const FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU = 'personal_questionnaire_pzu';
export const FILE_TYPE_INITIAL_TRAINING = 'initial_training';
export const FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN = 'agreement_on_wallet_reassign';
export const FILE_TYPE_OFWCA_APPLICATION = 'ofwca_application';
export const FILE_TYPE_IDD_TRAINING_STATEMENT = 'idd_training_statement';
export const FILE_TYPE_PARTNER_DATA = 'partner_data';
export const FILE_TYPE_CONFIDENTIALITY_AGREEMENT = 'confidentiality_agreement';
export const FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE = 'statement_on_the_right_to_dispose_of_real_estate';
export const FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS = 'declaration_of_consent_to_make_commission_deductions';
export const FILE_TYPE_ANOTHER_MULTI = 'another_multi';
export const FILE_TYPE_PERSONAL_DATA_CHANGE = 'personal_data_change';
export const FILE_TYPE_CONFIRMATION_PERSONAL_DATA_CHANGE = 'confirmation_personal_data_change';
export const FILE_TYPE_HANDOVER_PROTOCOL = 'handover_protocol';
export const FILE_TYPE_RETURN_PROTOCOL = 'return_protocol';
export const FILE_TYPE_MANDATE_QUESTIONNAIRE = 'mandate_questionnaire';
export const FILE_TYPE_AWARD_RECEPTION_PROTOCOL = 'award_reception_protocol';
export const FILE_TYPE_AML_CERTIFICATE = 'aml_certificate';

export const FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE = 'annex_new_contract_template';
export const FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING = 'annex_new_contract_template_without_automatic_billing';


export  const FILE_TYPE_RECEIPT_PROTOCOL = 'receipt_protocol';
export const FILE_TYPE_CONTRACT_WITH_EMPLOYEE = 'contract_with_employee';
export const FILE_TYPE_OVERCOMMISSION_AGREEMENT = 'overcommission_agreement';
export const FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM = 'sales_process_verification_form';
export const FILE_TYPE_ANNEX_LEAD = 'annex_lead';
export const FILE_TYPE_ANNEX_AUTOMATIC_BILLING = 'annex_automatic_billing';
export const FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING = 'annex_new_contract_template_and_automatic_billing';


export const DICT_TYPE_TEMPLATE_TYPE = 'template_type';
export const TEMPLATE_TYPE_CONTRACT = 'contract';
export const TEMPLATE_TYPE_TERMINATION = 'termination';
export const TEMPLATE_TYPE_STATEMENT = 'statement';
export const TEMPLATE_TYPE_AUTHORIZATION = 'authorization';
export const TEMPLATE_TYPE_OFWCA_APPLICATION = 'ofwca_application';
export const TEMPLATE_TYPE_PARTNER_DATA = 'partner_data';
export const TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION = 'annex_ofwca_application';
export const TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT = 'annex_commission_attachment';
export const TEMPLATE_TYPE_ANNEX_LEAD_TEMPLATE = 'annex_lead_template';
export const TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING = 'annex_new_contract_template_and_automatic_billing';
export const TEMPLATE_TYPE_CONFIDENTIALITY_AGREEMENT = 'confidentiality_agreement';
export const TEMPLATE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE = 'statement_on_the_right_to_dispose_of_real_estate';
export const TEMPLATE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS = 'declaration_of_consent_to_make_commission_deductions';
export const TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE = 'annex_new_contract_template';
export const TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING = 'annex_automatic_billing';
export const TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE = 'contract_with_employee';
export const TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY = 'agent_power_of_attorney';
export const TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION = 'distributor_information';
export const TEMPLATE_TYPE_INFORMATION_ABOUT_RODO = 'information_about_rodo';
export const TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION = 'declaration_for_deregistration';
export const TEMPLATE_TYPE_PERSONAL_DATA_CHANGE = 'personal_data_change';
export const TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING = 'annex_new_contract_template_without_automatic_billing';

export const DICT_TYPE_GENERATED_FIELDS = 'generated_fields';
export const GENERATED_FIELDS_SEPARATOR = 'separator';
export const GENERATED_EMPTY = 'empty';
export const DICT_TYPE_PARTNER_TAGS = 'partner_tags';
export const DICT_TYPE_PARTNER_TAGS_PARTNER_CONTRACT_OF_MANDATE = 'partner_contract_of_mandate';
export const PARTNER_TAGS_PROFIT = 'profit';

export const PARTNER_TAGS_GOOD_AGENT = 'good_agent';
export const PARTNER_TAGS_ASF_PREMIUM = 'asf_premium';
export const PARTNER_TAGS_ADAMCZUK = 'adamczuk';
export const PARTNER_TAGS_MULTISFERA = 'multisfera';
export const PARTNER_TAGS_MANDATE = 'mandate';
export const PARTNER_TAGS_LEASING = 'leasing';
export const PARTNER_TAGS_OCK = 'ock_agreement';
export const PARTNER_TAGS_TERMINAL = 'terminal';

export const DICT_TYPE_KRK_PAYER = 'krk_payer';
export const KRK_PAYER_ASF = 'asf';
export const KRK_PAYER_PARTNER = 'partner';

export const DICT_TYPE_KRK_STATUS = 'krk_status';
export const KRK_STATUS_ACTIVE = 'active';
export const KRK_STATUS_PENDING = 'pending';
export const KRK_STATUS_INACTIVE = 'inactive';

export const DICT_TYPE_WHAT_IS_NEEDED = 'registration_what_is_needed';
export const WHAT_IS_NEEDED_REGISTRATION = 'registration';
export const WHAT_IS_NEEDED_EXAM_AND_REGISTRATION = 'exam_and_registration';
export const WHAT_IS_NEEDED_RE_REGISTRATION = 're_registration';

export const DICT_TYPE_REGISTRATION_STATUS = 'registration_status';
export const REGISTRATION_STATUS_REGISTRATION_REQUEST = 'registration_request';
export const REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM = 'signed_up_for_an_exam';
export const REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY = 'sent_to_register_in_insurance_company';
export const REGISTRATION_STATUS_EXAM_PASSED = 'exam_passed';
export const REGISTRATION_STATUS_INCORRECT_DOCUMENTS = 'incorrect_documents';
export const REGISTRATION_STATUS_TO_BLOCK = 'to_block';
export const REGISTRATION_STATUS_TO_DEREGISTER = 'to_deregister';
export const REGISTRATION_STATUS_SENT_TO_DEREGISTER = 'sent_to_deregister';
export const REGISTRATION_STATUS_DEREGISTERED = 'deregistered';
export const REGISTRATION_STATUS_REGISTERED = 'registered';
export const REGISTRATION_STATUS_SENT_TO_BLOCK = 'sent_to_block';
export const REGISTRATION_STATUS_BLOCKED = 'blocked';
export const REGISTRATION_STATUS_RESIGNATION = 'resignation';
export const REGISTRATION_STATUS_DENIED_BY_INSURANCE_COMPANY = 'denied_by_insurance_company';
export const REGISTRATION_STATUS_SUSPENDED = 'suspended';
export const REGISTRATION_STATUS_TO_COMPLETE_IN_IC = 'to_complete_in_ic';

export const POST_TAG_TYPE = 'post_tag_type';
export const POST_TAG_TYPE_DEPARTMENT_TYPE = 'department_type';
export const POST_TAG_TYPE_POST_TYPE = 'post_type';
export const POST_TAG_TYPE_INSURANCE_COMPANY = 'insurance_company';
export const POST_TAG_TYPE_REMAINING = 'remaining';

export const LEAVE_APPLICATION_TYPE = 'leave_application_type';
export const LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE = 'occasional_leave';
export const LEAVE_APPLICATION_TYPE_CHILDCARE_LEAVE = 'childcare_leave';
export const LEAVE_APPLICATION_TYPE_ON_DEMAND_LEAVE = 'on_demand_leave';
export const LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE = 'recreational_leave';
export const LEAVE_APPLICATION_TYPE_RECEPTION = 'reception';


export const ACTIVE_REGISTRATION_STATUSES = [
  REGISTRATION_STATUS_REGISTERED,
  REGISTRATION_STATUS_REGISTRATION_REQUEST,
  REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM,
  REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY,
  REGISTRATION_STATUS_EXAM_PASSED,
  REGISTRATION_STATUS_INCORRECT_DOCUMENTS,
  REGISTRATION_STATUS_SUSPENDED,
  REGISTRATION_STATUS_SENT_TO_BLOCK,
  REGISTRATION_STATUS_BLOCKED,
  REGISTRATION_STATUS_TO_BLOCK,
];

export const ARCHIVE_REGISTRATION_STATUSES = [
  REGISTRATION_STATUS_TO_DEREGISTER,
  REGISTRATION_STATUS_SENT_TO_DEREGISTER,
  REGISTRATION_STATUS_DEREGISTERED,
  REGISTRATION_STATUS_RESIGNATION,
  REGISTRATION_STATUS_DENIED_BY_INSURANCE_COMPANY,
];

export const DICT_TYPE_DOUBLE_REGISTRATION = 'double_registration';
export const DOUBLE_REGISTRATION_NONE = 'none';

export const DICT_TYPE_REGISTRATION_WHAT_IS_NEEDED = 'registration_what_is_needed';
export const REGISTRATION_WHAT_IS_NEEDED_EXAM_AND_REGISTRATION = 'exam_and_registration';

export const DICT_TYPE_DEREGISTRATION_PACK_STATUS = 'deregistration_pack_status';
export const DEREGISTRATION_PACK_STATUS_NEW = 'new';
export const DEREGISTRATION_PACK_STATUS_SENT = 'sent';

export const AUTHORIZATION_STATUS_TO_GENERATE = 'to_generate';

export const DICT_TYPE_TERMINATION_TIME = 'termination_time';
export const TERMINATION_TIME_ONE_MONTH = 'one_month';
export const TERMINATION_TIME_TWO_MONTHS = 'two_months';
export const TERMINATION_TIME_THREE_MONTHS = 'three_months';
export const TERMINATION_TIME_IMMEDIATELY = 'immediately';

export const DICT_TYPE_TERMINATION_TYPE = 'termination_type';
export const TERMINATION_TYPE_BY_AGREEMENT = 'by_agreement';
export const TERMINATION_TYPE_BY_SIDES_AGREEMENT = 'by_sides_agreement';

export const DICT_TYPE_REGISTRATION_ID_TYPE = 'registration_id_type';
export const REGISTRATION_ID_TYPE_SENT = 'sent';
export const REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION = 'consent_to_dual_registration';

export const REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT = 'request_for_deletion_sent';

export const REGISTRATION_ID_TYPE_CHRONIE_ACCESS = 'chronie_access';

export const DICT_TYPE_MEETING_PLACE = 'meeting_place';
export const MEETING_PLACE_STATIONARY = 'stationary';

export const DICT_TYPE_MEETING_LEADER = 'meeting_leader';
export const MEETING_LEADER_INSURANCE_COMPANY = 'insurance_company';

export const MEETING_LEADER_ASF = 'asf';
export const MEETING_LEADER_OTHER = 'other';
export const MEETING_LEADER_MULTI = 'multi';

export const DICT_TYPE_MEETING_TYPE = 'meeting_type';
export const MEETING_TYPE_EXAM = 'exam';
export const MEETING_TYPE_IDD_TRAINING = 'idd_training';
export const MEETING_TYPE_NEW_AGENT_TRAINING = 'new_agent_training';
export const MEETING_TYPE_ADA = 'ada';
export const MEETING_TYPE_TRAINING = 'training';
export const MEETING_TYPE_MEETING = 'meeting';
export const MEETING_TYPE_OTHER = 'other';
export const MEETING_TYPE_ENTRANCE_EXAM = 'entrance_exam';

export const DICT_TYPE_MEETING_EXAM_TYPE = 'meeting_exam_type';
export const MEETING_EXAM_TYPE_100P = '100p';
export const MEETING_EXAM_TYPE_40P = '40p';
export const MEETING_EXAM_TYPE_30P = '30p';

export const DICT_TYPE_EXAM_TYPE = 'exam_type';
export const EXAM_TYPE_100P = '100p';
export const EXAM_TYPE_40P = '40p';

export const DICT_TYPE_MEETING_STATUS = 'meeting_status';
export const MEETING_STATUS_DURING_REGISTRATIONS = 'during_registrations';

export const DICT_TYPE_IDD_TRAINING_STATUS = 'idd_training_status';
export const IDD_TRAINING_STATUS_NOT_APPLICABLE = 'not_applicable';
export const IDD_TRAINING_STATUS_TO_BE_REAIZED = 'to_be_realized';
export const IDD_TRAINING_STATUS_DURING = 'during';

export const IMPORT_STATUS = 'import_status';
export const IMPORT_STATUS_PENDING = 'pending';
export const IMPORT_STATUS_IN_PROGRESS = 'in_progress';
export const IMPORT_STATUS_IMPORTED = 'imported';
export const IMPORT_STATUS_ERROR = 'error';
export const IMPORT_STATUS_IN_CONFIGURATION = 'in_configuration';

export const COMMISSION_IMPORT_ROW_STATUS = 'commission_import_row_status';
export const COMMISSION_IMPORT_ROW_STATUS_NEW = 'new';
export const COMMISSION_IMPORT_ROW_STATUS_ASSIGNED = 'assigned';
export const COMMISSION_IMPORT_ROW_STATUS_ASSIGNED_ID = '368';
export const COMMISSION_IMPORT_ROW_STATUS_SETTLED = 'settled';
export const COMMISSION_IMPORT_ROW_STATUS_SETTLED_ID = '369';
export const COMMISSION_IMPORT_ROW_STATUS_REJECTED = 'rejected';

export const RATE_THRESHOLD_40 = 'rate_threshold_40';
export const RATE_THRESHOLD_10 = 'rate_threshold_10';

export const COMMISSION_SETTLEMENT_STATUS_NEW = 'new';
export const COMMISSION_SETTLEMENT_STATUS_SETTLED = 'settled';
export const COMMISSION_SETTLEMENT_STATUS_CLOSED = 'closed';
export const COMMISSION_SETTLEMENT_STATUS_TO_GENERATE = 'to_generate';

export const COMMISSION_JOB_STATUS = 'job_status';
export const COMMISSION_JOB_STATUS_PENDING = 'pending';
export const COMMISSION_JOB_STATUS_IN_PROGRESS = 'in_progress';
export const COMMISSION_JOB_STATUS_IN_SUCCESS = 'success';
export const COMMISSION_JOB_STATUS_IN_ERROR = 'error';
export const PERMISSIONS_TYPE = 'permissions_type';

export const COMMISSION_JOB = 'commission_job';
export const COMMISSION_JOB_GENERATE_SETTLEMENTS = 'generateSettlements';
export const COMMISSION_JOB_GENERATE_INVOICES = 'generateInvoices';
export const COMMISSION_JOB_GENERATE_COMMISSION_STATEMENTS = 'generateCommissionStatements';
export const COMMISSION_JOB_CLOSE_MONTH = 'closeMonth';
export const COMMISSION_JOB_SEND_SETTLEMENTS_TO_PARTNERS = 'sendSettlementsToPartners';
export const INVOICE_DOCUMENT_TYPE = 'invoice_document_type';
export const INVOICE_DOCUMENT_TYPE_CREDIT = 'credit';
export const INVOICE_DOCUMENT_TYPE_CHARGE = 'charge';
export const COMMISSION_IMPORT_ERGO_HESTIA_JUPITER = 'jupiter';
export const COMMISSION_IMPORT_ERGO_HESTIA_MTU_JUPITER = 'mtu_jupiter';
export const COMMISSION_IMPORT_ERGO_HESTIA_IPEGAZ = 'ipegaz';
export const COMMISSION_IMPORT_ERGO_HESTIA_JUPITER_YCD = 'jupiter_ycd';
export const COMMISSION_IMPORT_GENERALI = 'generali';
export const COMMISSION_IMPORT_GENERALI_AGRO = 'generali_agro';
export const COMMISSION_IMPORT_GENERALI_PROAMA = 'proama';
export const COMMISSION_IMPORT_UNIQA_AGENT_PANEL = 'uniqa_panel';
export const COMMISSION_IMPORT_UNIQA_POS = 'uniqa_pos';
export const COMMISSION_IMPORT_UNIQA_CORPORATION = 'uniqa_corporation';

export const FILE_EXTENSION_DOCX = 'docx';
export const FILE_EXTENSION_XLSX = 'xlsx';

export const SERVICE_TYPE = 'service_type';
export const SERVICE_TYPE_SUPPORT = 'support';
export const SERVICE_TYPE_CORPORATION = 'corporation';

export const TYPE_OF_ACTIVITY_CORPORATION = 'type_of_activity_corporation';
export const TYPE_OF_ACTIVITY_CORPORATION_OFFEAR_PREPARATION = 'offer_preparation';
export const TYPE_OF_ACTIVITY_CORPORATION_COMPARE_OFFERS = 'compare_offers';
export const TYPE_OF_ACTIVITY_CORPORATION_INTERPRETATION_OWU = 'interpretation_owu';
export const TYPE_OF_ACTIVITY_CORPORATION_OTHER = 'other';
export const TYPE_OF_ACTIVITY_CORPORATION_SYSTEM_HELP = 'system_help';
export const TYPE_OF_ACTIVITY_CORPORATION_ISSUING_POLICY = 'issuing_policy';
export const TYPE_OF_ACTIVITY_CORPORATION_SENDING_PROCESS_GUIDELINES = 'sending_process_guidelines';
export const TYPE_OF_ACTIVITY_CORPORATION_PRODUCT_INQUIRY = 'product_inquiry';


export const DICT_TYPE_POST_STATUS = 'post_status';
export const POST_STATUS_PUBLISHED = 'published';
export const POST_STATUS_SKETCH = 'sketch';
export const POST_STATUS_TO_BE_PUBLISHED = 'to_be_published';

export const ADDRESS_IMPORT_TYPE = 'address_import_type';
export const ADDRESS_IMPORT_TYPE_CITY = 'city';
export const ADDRESS_IMPORT_TYPE_DISTRICT = 'district';
export const ADDRESS_IMPORT_TYPE_COMMUNE = 'commune';
export const ADDRESS_IMPORT_TYPE_STREET= 'street';
export const ADDRESS_IMPORT_TYPE_COMMUNIER = 'commune';
export const SALES_COMPENSA = 'sales_compensa';
export const SALES_COMPENSA_COMPENSA = 'compensa';
export const SALES_COMPENSA_WIENER = 'wiener';
export const DYNAMIC_DICTIONARY = 'dynamic_dictionary';
export const DYNAMIC_DICTIONARY_MANAGER_WIENER = 'manager_wiener';
export const DYNAMIC_DICTIONARY_COMPENSA_OFFICE = 'compensa_office';
export const DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT = 'compensa_office_profit';
export const DYNAMIC_DICTIONARY_ASF360 = 'asf360';
export const DYNAMIC_DICTIONARY_DEVICE_TYPE = 'device_type';
export const DYNAMIC_DICTIONARY_LICENSE_TYPE = 'license_type';
export const DYNAMIC_DICTIONARY_AFFILIATE_LINKS = 'affiliate_links';
export const DYNAMIC_DICTIONARY_CATEGORY = 'category';
export const DYNAMIC_DICTIONARY_WAREHOUSE = 'warehouse';
export const DYNAMIC_DICTIONARY_FUNCTION = 'function';
export const DYNAMIC_DICTIONARY_NOTE = 'note';
export const DYNAMIC_DICTIONARY_DEPARTMENT360 = 'department360';
export const DYNAMIC_DICTIONARY_TAG360 = 'tag360';
export const DYNAMIC_DICTIONARY_COMPANY360 = 'company360';

export const  RECEIVABLES_IMPORT_ROW_STATUS = 'receivables_import_row_status';
export const  RECEIVABLES_IMPORT_ROW_STATUS_REJECTED = 'rejected';
export const  RECEIVABLES_IMPORT_ROW_STATUS_NEW = 'new';
export const  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION = 'for_verification';
export const RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED = 'cancelled';
export const RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED = 'to_cancelled';
export const RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU = 'paid_to_tu';
export const RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_ASF = 'paid_to_asf';
export const RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED = 'payment_reported';

export const RECEIVABLES_IMPORT_ROW_STATUS_PAID  = 'paid';
export const RECEIVABLES_IMPORT_ROW_STATUS_REPORTED_FOR_SETTLEMENT = 'reported_for_settlement';
export const RECEIVABLES_IMPORT_ROW_STATUS_PARTIALLY_PAID  = 'partially_paid';
export const RECEIVABLES_IMPORT_ROW_STATUS_UNPAID = 'unpaid';

export const  RECEIVABLES_STATEMENT_STATUS = 'receivables_statement_status';
export const  RECEIVABLES_STATEMENT_STATUS_REPORTED_FOR_SETTLEMENT = 'reported_for_settlement';
export const  RECEIVABLES_STATEMENT_STATUS_PAID = 'paid';
export const  RECEIVABLES_STATEMENT_STATUS_PARTIALLY_PAID = 'partially_paid';
export const  RECEIVABLES_STATEMENT_STATUS_CANCELLED = 'cancelled';

export const DICT_TYPE_FORM_ROW_STATUS = 'form_row_status';
export const FORM_ROW_STATUS_SUCCESS = 'success';
export const FORM_ROW_STATUS_LOSS = 'loss';
export const FORM_ROW_STATUS_NEW = 'new';
export const FORM_ROW_STATUS_TO_BE_SERVED = 'to_br_served';

export const RECEIVABLES_PAYMENT_STATUS = 'receivables_payment_status';
export const RECEIVABLES_PAYMENT_STATUS_SETTLED = 'settled';
export const RECEIVABLES_PAYMENT_STATUS_UNSETTLED = 'unsettled';
export const RECEIVABLES_PAYMENT_STATUS_CANCELED = 'canceled';
export const RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT = 'outgoing_payment';

export const TYPE_OF_MEETING = 'type_of_meeting';
export const TYPE_OF_MEETING_MEETING = 'meeting';

export const AGENT_21_STATUS = 'agent_21_status';
export const AGENT_21_STATUS_REGISTRATION = 'registration';
export const AGENT_21_STATUS_RESIGNATION = 'resignation';
export const AGENT_21_STATUS_INVOICE_SENT = 'invoice_sent';
export const AGENT_21_STATUS_INVOICE_PAID = 'invoice_paid';
export const AGENT_21_STATUS_SEND_FOR_ACTIVATION = 'sent_for_activation';
export const AGENT_21_STATUS_PARTNER_NOTIFICATION = 'partner_notification';
export const AGENT_21_STATUS_ACTIVE = 'active';
export const AGENT_21_STATUS_IT_EXPIRES = 'it_expires';
export const AGENT_21_STATUS_APPLICATION_FOR_RENEWAL = 'application_for_renewal';
export const AGENT_21_STATUS_RENEWAL_INVOICE_SENT = 'renewal_invoice_sent';
export const AGENT_21_STATUS_CANCELLATION_OF_RENEWAL = 'cancellation_of_renewal';


export const TERMINAL_STATUS = 'terminal_status';
export const TERMINAL_STATUS_PAID = 'paid';
export const TERMINAL_STATUS_TO_BE_REALIZED = 'to_be_realized';
export const TERMINAL_STATUS_SUSPENDED = 'suspended';

export const TERMINALS_IMPORT_ROW_STATUS = 'terminals_import_row_status';
export const TERMINALS_IMPORT_ROW_STATUS_SETTLED = 'settled';
export const TERMINALS_IMPORT_ROW_STATUS_UNSETTLED = 'unsettled';
export const TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION = 'for_verification';

export const AFFILIATE_CODE_STATUS_ACTIVE = 'active';
export const AFFILIATE_CODE_STATUS_INACTIVE = 'inactive';

export const PERSONAL_DATA_CHANGE_STATUS = 'personal_data_change_status';
export const PERSONAL_DATA_CHANGE_STATUS_REPORTED = 'reported';
export const PERSONAL_DATA_CHANGE_STATUS_SENT_TO_IC = 'sent_to_ic';
export const PERSONAL_DATA_CHANGE_STATUS_COMPLETED = 'completed';

export const PAYMENT_STATUS = 'payment_status';
export const PAYMENT_STATUS_NEW = 'new';
export const PAYMENT_STATUS_PENDING = 'pending';
export const PAYMENT_STATUS_WAITING_FOR_CONFIRMATION = 'waiting_for_confirmation';
export const PAYMENT_STATUS_COMPLETED = 'completed';
export const PAYMENT_STATUS_CANCELED = 'canceled';
export const PAYMENT_STATUS_REJECTED = 'rejected';
export const PAYMENT_STATUS_REFUNDED = 'refunded';
export const PAYMENT_STATUS_CLOSED = 'closed';

export const RECEIVABLES_TRANSFER_STATUS = 'receivables_transfer_status';
export const RECEIVABLES_TRANSFER_STATUS_COMPLETED = 'completed';
export const RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED = 'to_be_completed';
export const RECEIVABLES_TRANSFER_STATUS_SUSPENDED = 'suspended';


export const WORKING_HOURS = 'working_hours';
export const WORKING_HOURS_7_16 = '7-16';
export const WORKING_HOURS_3_4 = '3-4';
export const WORKING_HOURS_7_8 = '7-8';
export const WORKING_HOURS_1_2 = '1-2';
export const WORKING_HOURS_FULL = 'full';

export const LEAVE_APPLICATION_STATUS = 'leave_application_status';
export const LEAVE_APPLICATION_STATUS_CANCEL = 'cancel';
export const LEAVE_APPLICATION_STATUS_REJECTED = 'rejected';
export const LEAVE_APPLICATION_STATUS_ACCEPTED = 'accepted';
export const LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE = 'for_acceptance';

export const LEAVE_APPLICATION_TIME = 'leave_application_time';
export const LEAVE_APPLICATION_TIME_FIRST = 'first';
export const LEAVE_APPLICATION_TIME_SECOND = 'second';
export const LEAVE_APPLICATION_TIME_FIRST_HOURS = 'first_hours';
export const LEAVE_APPLICATION_TIME_SECOND_HOURS = 'second_hours';

export const WZ_STATUS = 'wz_status';
export const WZ_STATUS_TO_RELEASE = 'to_release';
export const WZ_STATUS_IN_PREPARATION = 'in_preparation';
export const WZ_STATUS_RELEASED = 'released';

export const ROOM = 'room';
export const ROOM_PGE = 'pge';

export const HIPERIO_TEST_ACCESS_FORM_STATUS  = 'hiperio_test_access_form_status';
export const HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING = 'pending';
export const HIPERIO_TEST_ACCESS_FORM_STATUS_ACCEPTED = 'accepted';
export const HIPERIO_TEST_ACCESS_FORM_STATUS_REJECTION = 'rejection';

export const HIPERIO_USER_JOB_STATUS = 'hiperio_user_job_status';
export const HIPERIO_USER_JOB_STATUS_PENDING = 'pending';
export const HIPERIO_USER_JOB_STATUS_IN_PROGRESS = 'in_progress';
export const HIPERIO_USER_JOB_STATUS_CREATED = 'created';
export const HIPERIO_USER_JOB_STATUS_TO_BE_CREATED = 'to_be_created';
export const HIPERIO_USER_JOB_STATUS_API_ERROR = 'api_error';

export const IS_PUBLIC_AGENT_INFORMATION_DOCUMENT = [
  FILE_TYPE_AUTHORIZATION, TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY, TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION
];

export const AUTOMATIC_PARTNER_TAGS = [
  PARTNER_TAGS_ADAMCZUK,
  PARTNER_TAGS_ASF_PREMIUM,
  PARTNER_TAGS_MULTISFERA,
  PARTNER_TAGS_MANDATE,
  PARTNER_TAGS_LEASING,
  PARTNER_TAGS_OCK,
  PARTNER_TAGS_TERMINAL,
  PARTNER_TAGS_PROFIT,
];

export const COMMISSION_STATEMENT_GENERATION_CRITERIA_TYPE = [
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_PROFIT
]

@Injectable({
  providedIn: 'root'
})
export class DictService {
  loaded = false;

  private readonly dictSubject: ReplaySubject<Array<Dictionary>> = new ReplaySubject();

  constructor(
    private httpClient: HttpClient,
  ) {
    this.loadDict();
  }

  public loadDict(): void {
    this.httpClient.get('/rest/crm/dictionary')
      .pipe(first())
      .subscribe((response: ListResponse<Dictionary>) => {
        this.dictSubject.next(response.items);
        this.loaded = true;
      });
  }

  public getDictSubject(): ReplaySubject<Array<Dictionary>> {
    return this.dictSubject;
  }

  public getKey(id: number): Observable<string> {
    this.loadIfNotLoaded();
    const keyObservable: ReplaySubject<string> = new ReplaySubject<string>(1);

    this.dictSubject.pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.some((el: Dictionary) => {
          if (el.id === id) {
            keyObservable.next(el.key);
            keyObservable.complete();
            return true;
          }

          return false;
        });

        keyObservable.next('');
        keyObservable.complete();
      });

    return keyObservable.pipe(first());
  }

  public getId(key: string, type: string): Observable<number> {
    this.loadIfNotLoaded();
    const idObservable: ReplaySubject<number> = new ReplaySubject<number>(1);

    this.dictSubject.pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.some((el: Dictionary) => {
          if (el.key === key && el.type === type) {
            idObservable.next(el.id);
            idObservable.complete();
            return true;
          }

          return false;
        });

        idObservable.next(-1);
        idObservable.complete();
      });

    return idObservable.pipe(first());
  }

  public get(key: string, type: string): Observable<Dictionary> {
    this.loadIfNotLoaded();
    const idObservable: ReplaySubject<Dictionary> = new ReplaySubject<Dictionary>(1);

    this.dictSubject.pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.some((el: Dictionary) => {
          if (el.key === key && el.type === type) {
            idObservable.next(el);
            idObservable.complete();
            return true;
          }

          return false;
        });

        idObservable.next(null);
        idObservable.complete();
      });

    return idObservable.pipe(first());
  }

  public getDict(id: number): Observable<Dictionary> {
    this.loadIfNotLoaded();
    const dictObservable: ReplaySubject<Dictionary> = new ReplaySubject<Dictionary>(1);

    this.dictSubject.pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.some((el: Dictionary) => {
          if (el.id === id) {
            dictObservable.next(el);
            dictObservable.complete();
            return true;
          }

          return false;
        });

        dictObservable.complete();
      });

    return dictObservable.pipe(first());
  }

  private loadIfNotLoaded(): void {
    if (!this.loaded) {
      this.loadDict();
    }
  }

}
